export default __webpack_public_path__ + "static/media/profile.0d3a628d.jpg";